import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgCheckmarkIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 14 11">
      <path d="M4.74999 8.14995L1.59999 4.99995L0.549988 6.04995L4.74999 10.2499L13.75 1.24995L12.7 0.199951L4.74999 8.14995Z" fill="currentColor"/>
    </SvgIcon>
  );
};

export default SvgCheckmarkIcon;
